var render = function render(){var _vm=this,_c=_vm._self._c;return _c('v-app',[_c('AppBar'),_c('v-main',{staticClass:"main"},[_c('v-container',{attrs:{"fluid":""}},[(_vm.Loading)?_c('v-loading'):_c('MainContainer')],1)],1),_c('Footer')],1)
}
var staticRenderFns = []

export { render, staticRenderFns }